import { Query } from '@apollo/client/react/components';
/*
before touching this file
PLEASE READ
./README.refactoringInProgress.md
*/

import * as React from 'react';
import ErrorReporter from '../../../app/components/ErrorReporter';
import type {
  // @ts-expect-error ts-migrate(2305) FIXME: Module '"queries/__generated__/globalGQLTypes"' ha... Remove this comment to see the full error message
  ParticipantMessagingState,
  // @ts-expect-error ts-migrate(2305) FIXME: Module '"queries/__generated__/globalGQLTypes"' ha... Remove this comment to see the full error message
  ClassSearchability,
} from 'queries/__generated__/globalGQLTypes';

import CLASS_SETTINGS_QUERY from 'groups/queries/ClassSettingsQuery.gql';
import type {
  ClassSettings,
  ClassSettingsVariables,
} from 'groups/queries/__generated__/ClassSettings';

import GroupOptionsUnder13Checkbox from './GroupOptionsUnder13Checkbox';
import ClassSearchabilityContainer from './ClassSearchabilityContainer/ClassSearchabilityContainer';
import RequestToJoinContainer from './RequestToJoinContainer/RequestToJoinContainer';
import ParticipantMessagingSelectContainer from './ParticipantMessagingSelectContainer/ParticipantMessagingSelectContainer';

import LoadingIndicator from 'components/LoadingIndicator';

import './GroupOptionsForm.scss';
import Notice from 'components/Notice';
import Text from 'components/Text';
import { FormattedMessage } from 'lib/intl';

type Props = {
  hasChildren: boolean | undefined | null;
  searchable: ClassSearchability | undefined | null; // GroupOptionsClassSearchabilityCheckbox > searchabilityAndMessageabilityCheckbox. Soon to be deprecated,
  classSearchabilityEnabled: ClassSearchability | undefined | null;
  participantMessaging: string | undefined | null;
  onChange: Function | undefined | null;
  hideUnderageNote: boolean | undefined | null;
  requestToJoinEnabled: boolean | undefined | null;
  groupUuid: string | undefined | null;
  showClassSearchability: boolean;
  canCreateU13: boolean;
};

type State = {
  query: string;
  searchable: ClassSearchability;
  classSearchabilityEnabled: ClassSearchability;
  requestToJoinEnabled: boolean;
  participantMessaging: ParticipantMessagingState;
};

/**
 * https://app.asana.com/0/740899735370516/1202989613759303/f
 */
const shouldDisableSettings = (settingsLocked: boolean, districtId?: number) => {
  return settingsLocked || districtId === 534144;
};

class GroupOptionsForm extends React.Component<Props, State> {
  // @ts-expect-error ts-migrate(7022) FIXME: 'props' implicitly has type 'any' because it does ... Remove this comment to see the full error message
  static props = this.props;

  static defaultProps = {
    hasChildren: true,
    showClassSearchability: false,
    classSearchabilityEnabled: null,
    searchable: true,
    requestToJoinEnabled: null,
    groupUuid: '',
    participantMessaging: null,
    canCreateU13: false,
  };

  // @ts-expect-error ts-migrate(2416) FIXME: Property 'state' in type 'GroupOptionsForm' is not... Remove this comment to see the full error message
  state = {
    hasChildren: this.props.hasChildren,
    classSearchabilityEnabled: this.props.classSearchabilityEnabled,
    searchable: this.props.searchable,
    requestToJoinEnabled: this.props.requestToJoinEnabled,
    participantMessaging: this.props.participantMessaging,
  };

  // https://fb.me/react-unsafe-component-lifecycles
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      searchable: nextProps.searchable,
    });
  }

  getValues = () => {
    return {
      has_children: this.props.canCreateU13 && this.state.hasChildren,
      searchable: this.state.searchable,
      classSearchabilityEnabled: this.state.classSearchabilityEnabled,
      request_to_join_enabled: this.state.requestToJoinEnabled,
    };
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'name' implicitly has an 'any' type.
  toggle = (name) => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ [x: number]: boolean; }' is no... Remove this comment to see the full error message
    this.setState({ [name]: !this.state[name] });
    if (this.props.onChange) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      this.props.onChange(name, !this.state[name]);
    }
  };

  render() {
    const { showClassSearchability, groupUuid } = this.props;
    // hideUnderageNote is being passed in as a string for some reason
    // @ts-expect-error ts-migrate(2367) FIXME: This condition will always return 'false' since th... Remove this comment to see the full error message
    const hideUnderageNote = this.props.hideUnderageNote === 'true';
    const hasChildren = !!this.state.hasChildren;
    const under13Checked = !this.props.canCreateU13 || !hideUnderageNote;
    const under13Disabled = !this.props.canCreateU13;

    if (!groupUuid) {
      return (
        <GroupOptionsUnder13Checkbox
          checked={under13Checked}
          disabled={under13Disabled}
          hasChildren={hasChildren}
          toggle={this.toggle}
          isModal={true}
        />
      );
    }
    return (
      <Query<ClassSettings, ClassSettingsVariables>
        query={CLASS_SETTINGS_QUERY}
        variables={{ groupUuid }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading && !data?.classSettingsScreen) {
            return <LoadingIndicator />;
          }

          if (error) {
            console.error('GroupOptionsForm - unable to load class settings', error);
            return <ErrorReporter error="GroupOptionsForm - unable to load class settings" />;
          }

          // Apollo has this in-between state of not loading and not providing any data
          if (!data?.classSettingsScreen) {
            return null;
          }

          const {
            canEditParticipantMessagingState,
            participantMessagingState,
            participantMessagingSchoolRecommendation,
            canEditSearchability,
            searchability,
            searchabilitySchoolRecommendation,
            requestToJoinEnabled,
            requestToJoinEnabledRecommendation,
            canEditWillOnlyMessage13AndOlder,
            organization,
            areClassSettingsLockedByOrg,
          } = data.classSettingsScreen;

          const districtId = organization?.parentId ?? undefined;
          const disableSettings = shouldDisableSettings(areClassSettingsLockedByOrg, districtId);

          return (
            <React.Fragment>
              {areClassSettingsLockedByOrg && (
                <Text element="p">
                  <Notice color="whiteout">
                    <FormattedMessage id="admin.classSettings.lockSettings.locked.class" />
                  </Notice>
                </Text>
              )}
              {showClassSearchability && canEditSearchability && (
                <ClassSearchabilityContainer
                  disabled={disableSettings}
                  classSearchabilityEnabled={this.state.classSearchabilityEnabled}
                  setClassSearchabilityEnabled={(searchability: ClassSearchability) =>
                    this.setState({ classSearchabilityEnabled: searchability })
                  }
                  classSearchabilityFromBackend={searchability}
                  classSearchabilitySchoolDefault={searchabilitySchoolRecommendation || ''}
                  groupUuid={this.props.groupUuid}
                  toggleSearchable={() => this.toggle('searchable')}
                />
              )}
              <RequestToJoinContainer
                disabled={disableSettings}
                requestToJoinFromBackend={requestToJoinEnabled}
                requestToJoinEnabledRecommendation={requestToJoinEnabledRecommendation || ''}
                requestToJoinFromFrontend={this.state.requestToJoinEnabled}
                groupUuid={this.props.groupUuid}
                setRequestToJoinEnabled={(enabled) =>
                  this.setState({ requestToJoinEnabled: enabled })
                }
              />
              {canEditParticipantMessagingState && (
                <ParticipantMessagingSelectContainer
                  disabled={disableSettings}
                  participantMessagingFromBackend={participantMessagingState}
                  participantMessagingSchoolDefault={participantMessagingSchoolRecommendation || ''}
                  groupUuid={this.props.groupUuid}
                  participantMessagingFromFrontend={this.state.participantMessaging}
                  setParticipantMessagingValue={(participantMessagingValue: string) => {
                    this.setState({ participantMessaging: participantMessagingValue });
                  }}
                />
              )}
              {canEditWillOnlyMessage13AndOlder && this.props.canCreateU13 && (
                <GroupOptionsUnder13Checkbox
                  checked={under13Checked}
                  disabled={under13Disabled || areClassSettingsLockedByOrg}
                  hasChildren={hasChildren}
                  toggle={this.toggle}
                  isModal={false}
                />
              )}
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

export default GroupOptionsForm;
